<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed && Booking">

<!-- ============================================================ -->
<!-- PRINT FORM — hidden on screen, shown only when printing      -->
<!-- ============================================================ -->
<div class="print-only" style="font-family: Arial, sans-serif; padding: 24px; color: #000;">

    <div style="text-align: right; font-size: 0.75rem; color: #666; margin-bottom: 8px;">Printed {{today | date:'dd/MM/yyyy HH:mm'}}</div>
    <h2 style="text-align: center; font-weight: bold; font-size: 1.3rem; margin: 0 0 20px 0; letter-spacing: 0.05em;">BOOKING FORM</h2>

    <!-- Single table for all detail rows + questions + financials -->
    <table style="width: 100%; border-collapse: collapse;">
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold; width: 38%;">Customer</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.name}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Email Address</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.customer?.email || ''}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Date</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.startTime | date:'EEEE d MMMM yyyy'}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Time</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.startTime | date:'HH:mm' : 'UTC'}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Mobile Number</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.customer?.mobile || ''}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Number of Guests</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.guests}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Admissions</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{getAdmissionsText()}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Booking Ref</td>
            <td style="border: 1px solid #000; padding: 5px 8px; font-family: monospace;">{{Booking.bookingIdHR}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Package</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.packageName}} ({{Booking.showresourcestring}})</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Confirmed Number</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">&nbsp;</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Allergies</td>
            <td style="border: 1px solid #000; padding: 5px 8px;" [style.color]="getAllergyDetail() ? '#c00' : '#000'" [style.fontWeight]="getAllergyDetail() ? 'bold' : 'normal'">{{getAllergyDetail() || 'None known'}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Extras</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{getExtrasText()}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Additional Notes</td>
            <td style="border: 1px solid #000; padding: 20px 8px;">{{Booking.notes || ''}}</td>
        </tr>
        <!-- Booking Questions (conditional) -->
        <ng-container *ngIf="packageHasQuestions">
            <tr>
                <td colspan="2" style="border: 1px solid #000; padding: 5px 8px; font-weight: bold; background: #f0f0f0;">Booking Questions</td>
            </tr>
            <tr *ngFor="let bq of Booking.questionnaire.bookingquestions">
                <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">{{bq.questiontext}}</td>
                <td style="border: 1px solid #000; padding: 5px 8px;">{{getAnswerText(bq)}}</td>
            </tr>
        </ng-container>
        <!-- Financial summary -->
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Total</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.total | currency: CurrencySymbol}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #000; padding: 5px 8px; font-weight: bold;">Outstanding Balance</td>
            <td style="border: 1px solid #000; padding: 5px 8px;">{{Booking.outstanding | currency: CurrencySymbol}}</td>
        </tr>
    </table>

    <!-- Waivers (separate table — different column count) -->
    <div *ngIf="packageHasWaivers" style="margin-top: 16px;">
        <table style="width: 100%; border-collapse: collapse;">
            <tr>
                <td colspan="4" style="border: 1px solid #000; padding: 5px 8px; font-weight: bold; background: #f0f0f0;">Waivers</td>
            </tr>
            <ng-container *ngIf="waiverItems.length > 0; else noWaiversPrint">
                <tr style="background: #f9f9f9;">
                    <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold; width: 18%;">Waiver ID</td>
                    <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold; width: 18%;">Date Signed</td>
                    <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">Signed By</td>
                    <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold; width: 14%; text-align: center;">Participant</td>
                </tr>
                <ng-container *ngFor="let wi of waiverItems">
                    <tr>
                        <td style="border: 1px solid #000; padding: 4px 8px; font-family: monospace;">{{wi.waiveridhr}}</td>
                        <td style="border: 1px solid #000; padding: 4px 8px;">{{wi.signeddate | date:'dd/MM/yyyy'}}</td>
                        <td style="border: 1px solid #000; padding: 4px 8px;">{{wi.firstname}} {{wi.lastname}}</td>
                        <td style="border: 1px solid #000; padding: 4px 8px; text-align: center;">{{wi.isparticipant ? 'Yes' : 'No'}}</td>
                    </tr>
                    <tr *ngIf="wi.children?.length > 0">
                        <td colspan="4" style="border: 1px solid #000; padding: 4px 8px 4px 20px; font-size: 0.85em; color: #444;">
                            <b>Children:</b>
                            <span *ngFor="let child of wi.children; let last = last">
                                {{child.firstname}} {{child.lastname}}<span *ngIf="child.dateofbirth"> (DOB: {{child.dateofbirth | date:'dd/MM/yyyy'}}, age {{calculateChildAge(child.dateofbirth)}})</span><span *ngIf="!last">, </span>
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
            <ng-template #noWaiversPrint>
                <tr>
                    <td colspan="4" style="border: 1px solid #000; padding: 6px 8px; color: #666; font-style: italic;">No waivers signed yet.</td>
                </tr>
            </ng-template>
        </table>
    </div>


</div>

<!-- ============================================================ -->
<!-- NORMAL SCREEN VIEW                                            -->
<!-- ============================================================ -->
<div class="print-hide p-3 flex flex-column flex-auto">

    <!-- Back button -->
    <div style="margin-bottom: 12px; text-align: right;">
        <button pButton type="button" class="p-button-outlined p-button-sm" style="height: 34px;" (click)="goBack()">
            <span class="pi pi-chevron-left" style="margin-right: 6px;"></span>
            <span>{{backLabel}}</span>
        </button>
    </div>

    <!-- Summary Card -->
    <div class="shadow-2 border-round" style="margin-bottom: 20px; overflow: hidden;">

        <!-- Header bar -->
        <div style="background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%); padding: 20px 24px; color: white;">
            <div style="text-align: center; padding: 8px 0;">
                <div style="font-size: 1.6rem; font-weight: 700; letter-spacing: -0.01em; margin-bottom: 6px;">{{Booking.name}}</div>
                <div style="opacity: 0.85; font-size: 0.95rem; margin-bottom: 4px;">{{Booking.startTime | date:'EEEE d MMMM yyyy'}} &bull; {{Booking.startTime | date:'HH:mm' : 'UTC'}}</div>
                <div style="display: inline-block; font-size: 1.1rem; font-weight: 700; font-family: ui-monospace, monospace; background: rgba(255,255,255,0.15); padding: 4px 16px; border-radius: 6px; letter-spacing: 0.05em;">{{Booking.bookingIdHR}}</div>
            </div>
        </div>

        <!-- Info rows -->
        <div class="surface-card" style="padding: 20px 24px;">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0;">

                <div style="padding: 10px 0; border-bottom: 1px solid #f1f5f9;">
                    <span class="pi pi-envelope" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Email</b> : {{Booking.customer?.email || '-'}}
                </div>

                <div style="padding: 10px 0; border-bottom: 1px solid #f1f5f9;">
                    <span class="pi pi-mobile" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Phone</b> : {{Booking.customer?.mobile || '-'}}
                </div>

                <div style="padding: 10px 0; border-bottom: 1px solid #f1f5f9;">
                    <span class="pi pi-box" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Package</b> : {{Booking.packageName }} ({{Booking.showresourcestring}})
                </div>

                <div style="padding: 10px 0; border-bottom: 1px solid #f1f5f9;">
                    <span class="pi pi-users" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Guests</b> : {{Booking.guests}}
                </div>

                <div style="padding: 10px 0; border-bottom: 1px solid #f1f5f9;">
                    <span class="pi pi-list" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Admissions</b> : {{getAdmissionsText() || '-'}}
                </div>

                <div style="padding: 10px 0; border-bottom: 1px solid #f1f5f9;">
                    <span class="pi pi-pound" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Total</b> : <b>{{Booking.total | currency: CurrencySymbol}}</b>
                </div>

                <div style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; grid-column: 1 / -1;">
                    <span class="pi pi-pound" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Outstanding</b> :
                    <span [style.color]="Booking.outstanding > 0 ? '#ef4444' : 'inherit'" [style.font-weight]="Booking.outstanding > 0 ? '700' : 'normal'">
                        {{Booking.outstanding | currency: CurrencySymbol}}
                    </span>
                </div>

                <div *ngIf="getExtrasText()" style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; grid-column: 1 / -1;">
                    <span class="pi pi-star" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Extras</b> : {{getExtrasText()}}
                </div>

                <div *ngIf="Booking.upgradetext" style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; grid-column: 1 / -1;">
                    <span class="pi pi-arrow-up" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Upgrades</b> : {{Booking.upgradetext}}
                </div>

                <div *ngIf="Booking.addontext" style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; grid-column: 1 / -1;">
                    <span class="pi pi-plus-circle" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Add-ons</b> : {{Booking.addontext}}
                </div>

                <div *ngIf="Booking.notes" style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; grid-column: 1 / -1;">
                    <span class="pi pi-file" style="margin-right: 10px; color: #6366f1;"></span>
                    <b>Notes</b> : {{Booking.notes}}
                </div>

                <div *ngIf="Booking.allergy" style="padding: 10px 0; grid-column: 1 / -1;">
                    <span class="pi pi-exclamation-triangle" style="margin-right: 10px; color: #ef4444;"></span>
                    <b style="color: #ef4444;">Allergy</b> : <span style="color: #ef4444; font-weight: 600;">{{Booking.allergy}}</span>
                </div>

            </div>
        </div>

    </div>

    <!-- Waivers -->
    <div *ngIf="packageHasWaivers" class="surface-card p-4 shadow-2 border-round" style="margin-bottom: 20px;">
        <h4 style="margin-top: 0; margin-bottom: 16px; border-bottom: 1px solid #e2e8f0; padding-bottom: 10px;">
            <span class="pi pi-file-edit" style="margin-right: 8px; color: #6366f1;"></span>Waivers
        </h4>
        <div *ngIf="waiverItems.length === 0" style="color: #64748b;">
            No waivers have been signed yet.
        </div>
        <p-table *ngIf="waiverItems.length > 0" [value]="waiverItems">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 14%;">Waiver ID</th>
                    <th style="width: 14%;">Date Signed</th>
                    <th>Signed By</th>
                    <th style="width: 12%; text-align: center;">Participant</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-wi>
                <tr>
                    <td style="font-family: monospace;">{{wi.waiveridhr}}</td>
                    <td>{{wi.signeddate | date:'dd/MM/yyyy'}}</td>
                    <td>{{wi.firstname}} {{wi.lastname}}</td>
                    <td style="text-align: center;">
                        <span *ngIf="wi.isparticipant" class="pi pi-check" style="color: #22c55e;"></span>
                        <span *ngIf="!wi.isparticipant" class="pi pi-times" style="color: #ef4444;"></span>
                    </td>
                </tr>
                <tr *ngIf="wi.children?.length > 0">
                    <td colspan="4" style="padding: 12px 16px; background: #f8fafc;">
                        <b style="font-size: 0.85rem; color: #64748b;">Children covered:</b>
                        <div *ngFor="let child of wi.children" style="margin-top: 6px; font-size: 0.9rem;">
                            {{child.firstname}} {{child.lastname}}
                            <span *ngIf="child.dateofbirth"> &mdash; DOB: {{child.dateofbirth | date:'dd/MM/yyyy'}} (age {{calculateChildAge(child.dateofbirth)}})</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Booking Questions -->
    <div *ngIf="packageHasQuestions" class="surface-card p-4 shadow-2 border-round" style="margin-bottom: 20px;">
        <h4 style="margin-top: 0; margin-bottom: 16px; border-bottom: 1px solid #e2e8f0; padding-bottom: 10px;">Booking Questions</h4>

        <div *ngIf="Booking.questionnaire?.bookingquestions?.length > 0">
            <div *ngFor="let bq of Booking.questionnaire.bookingquestions" style="margin-bottom: 18px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9;">

                <div style="color: #64748b; font-size: 0.8rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px;">{{bq.questiontext}}</div>

                <!-- Free text -->
                <div *ngIf="bq.questiontype == 'FREETEXT'" style="font-size: 1rem;">
                    {{bq.answers?.freetextanswer || '-'}}
                </div>

                <!-- Number -->
                <div *ngIf="bq.questiontype == 'NUMBER' || bq.questiontype == 'AGE'" style="font-size: 1rem;">
                    {{bq.answers?.numberanswer ?? '-'}}
                </div>

                <!-- Date -->
                <div *ngIf="bq.questiontype == 'DATE'" style="font-size: 1rem;">
                    {{bq.answers?.dateanswer ? (bq.answers.dateanswer | date:'dd/MM/yyyy') : '-'}}
                </div>

                <!-- Allergy -->
                <div *ngIf="bq.questiontype == 'ALLERGY'" style="font-size: 1rem;">
                    <span *ngIf="!bq.answers?.allergyanswer?.allergypresent">No allergy</span>
                    <span *ngIf="bq.answers?.allergyanswer?.allergypresent" style="color: #ef4444; font-weight: 600;">
                        {{bq.answers.allergyanswer.allergytext || 'Allergy present (no detail given)'}}
                    </span>
                </div>

                <!-- Multi choice single -->
                <div *ngIf="bq.questiontype == 'MULTICHOICESINGLE'" style="font-size: 1rem;">
                    {{bq.answers?.multichoicesingleanswer?.listitemtext || '-'}}
                </div>

                <!-- Multi choice multiple -->
                <div *ngIf="bq.questiontype == 'MULTICHOICEMULTIPLE'" style="font-size: 1rem;">
                    {{getMultiChoiceAnswers(bq.answers?.multichoicemultianswer)}}
                </div>

                <!-- Register. Same people, minus the gender, and the last field is titled with
                     whatever wording the question was given. -->
                <div *ngIf="bq.questiontype == 'REGISTER'">
                    <div *ngFor="let person of bq.answers?.birthdayanswers; let i = index" style="margin-bottom: 8px; padding: 8px; background: #f8fafc; border-radius: 6px;">
                        <span style="font-weight: 600;">{{person.name || 'Person ' + (i+1)}}</span>
                        <span *ngIf="person.age"> &mdash; Age: {{person.age}}</span>
                        <span *ngIf="person.birthdate && person.birthdate != '-*-'"> &mdash; DOB: {{person.birthdate}}</span>
                        <span *ngIf="person.interests"> &mdash; {{bq.warningtext}}: {{person.interests}}</span>
                    </div>
                </div>

                <!-- Birthday -->
                <div *ngIf="bq.questiontype == 'BIRTHDAY'">
                    <div *ngFor="let person of bq.answers?.birthdayanswers; let i = index" style="margin-bottom: 8px; padding: 8px; background: #f8fafc; border-radius: 6px;">
                        <span style="font-weight: 600;">{{person.name || 'Person ' + (i+1)}}</span>
                        <span *ngIf="person.age"> &mdash; Age: {{person.age}}</span>
                        <span *ngIf="person.birthdate && person.birthdate != '-*-'"> &mdash; DOB: {{person.birthdate}}</span>
                        <span *ngIf="person.gender"> &mdash; {{person.gender}}</span>
                        <span *ngIf="person.interests"> &mdash; Interests: {{person.interests}}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Actions -->
    <div class="surface-card p-4 shadow-2 border-round no-print">
        <h4 style="margin-top: 0; margin-bottom: 16px; border-bottom: 1px solid #e2e8f0; padding-bottom: 10px;">Actions</h4>

        <!-- Send Email Template row -->
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 20px; flex-wrap: wrap;">
            <p-dropdown [options]="EmailTemplates" [style]="{'width': '300px'}" placeholder="Select a template" [showClear]="true" [(ngModel)]="selectedEmailTemplate" optionLabel="name"></p-dropdown>
            <button pButton type="button" class="p-button p-button-success" style="height: 44px;" (click)="sendEmailToBooking()">
                <span class="pi pi-send" style="margin-right: 8px;"></span>
                <span>Send Email Template</span>
            </button>
            <div *ngIf="!templateValid" style="color: #ef4444; font-size: 0.85rem;">Please select a template first.</div>
        </div>

        <!-- Main action buttons -->
        <div style="display: flex; gap: 10px; flex-wrap: wrap;">
            <button pButton type="button" class="p-button p-button-warning" style="height: 50px;" (click)="resendConfirmation()">
                <span class="pi pi-envelope" style="margin-right: 8px;"></span>
                <span>Re-send Confirmation</span>
            </button>

            <button pButton type="button" class="p-button" style="height: 50px;" (click)="editBooking()">
                <span class="pi pi-pencil" style="margin-right: 8px;"></span>
                <span>Edit Booking</span>
            </button>

            <button pButton type="button" class="p-button p-button-secondary" style="height: 50px;" (click)="print()">
                <span class="pi pi-print" style="margin-right: 8px;"></span>
                <span>Print</span>
            </button>

            <button pButton type="button" class="p-button p-button-success" style="height: 50px;" (click)="confirmNumbers()">
                <span class="pi pi-check-circle" style="margin-right: 8px;"></span>
                <span>Confirm Numbers</span>
            </button>

            <button *ngIf="!Booking.acknowledged" pButton type="button" class="p-button p-button-warning" style="height: 50px;" (click)="acknowledgeBooking()">
                <span class="pi pi-thumbs-up" style="margin-right: 8px;"></span>
                <span>Acknowledge</span>
            </button>
        </div>
    </div>

</div><!-- end print-hide -->
</div><!-- end *ngIf wrapper -->
